import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { ReactionGroup } from "./message-derivations";
import { formatReactorList } from "./reaction-formatters";

interface MessageReactionsProps {
  groups: Map<string, ReactionGroup>;
  onReact: (emoji: string) => void;
}

export function MessageReactions({ groups, onReact }: MessageReactionsProps) {
  if (groups.size === 0) return null;
  return (
    <TooltipProvider delayDuration={300}>
      <div className="mt-1 flex flex-wrap gap-1">
        {Array.from(groups.entries()).map(([emoji, group]) => (
          <Tooltip key={emoji}>
            <TooltipTrigger asChild>
              <Button
                type="button"
                variant="ghost"
                size="tiny"
                onClick={() => onReact(emoji)}
                className={cn(
                  "h-auto gap-1 rounded-full border px-1.5 py-0.5 text-xs font-normal",
                  group.hasOwn
                    ? "bg-info-muted border-info/40"
                    : "border-border bg-foreground/[0.06] hover:bg-foreground/[0.08]",
                )}
              >
                <span>{emoji}</span>
                <span className="text-muted-foreground">{group.count}</span>
              </Button>
            </TooltipTrigger>
            <TooltipContent side="top" className="max-w-[260px] text-center">
              <div>
                {formatReactorList({
                  users: group.users,
                  viewerName: group.viewerEntry,
                })}
              </div>
              <div className="mt-0.5 text-muted-foreground">
                {group.hasOwn
                  ? `Click to remove ${emoji}`
                  : `Click to react with ${emoji}`}
              </div>
            </TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
}
